import { getAllInfoByISO } from 'iso-country-currency';

function getTimezone() {
  return new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
}

function getLanguages() {
  return navigator?.languages || (navigator?.language ? [navigator.language] : ['en-GB']);
}

export default function getUserLocale() {
  const platform = 'web';
  const last_login = new Date().toISOString();
  const languages = getLanguages();
  const timezone = getTimezone();
  const currency = getAllInfoByISO(languages[0].split('-')[1]);
  return {
    language: languages,
    timezone,
    platform,
    last_login,
    currency
  };
}
